module.exports = __webpack_public_path__ + "img/portfolio.28cd0231.png";